import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { isNullOrUndefined } from 'util';
import { DATE_FORMAT, STORE_LIST, ADS_LIST, STORE_SPONSORSHIP, ROWBUTTONS_LENGTH, NO_RECORDS_FOUND, ADS_TITLE, STORE_NAME_DRAG } from '../../utils/constants';
import moment from 'moment';

//REQUIRED PROPS
// tableHeaders, tableColumns, draggableList, updateDraggedList

const DraggableTable = (props) => {
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = (result) => {
        if (!result.destination) { return; }

        const newList = reorder(props.draggableList, result.source.index, result.destination.index);
        props.updateDraggedList(newList);
        document.getElementById(result.draggableId).focus();
    }

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            {props.customMessage && (<p>{props.customMessage}</p>)}
            <Table bordered>
                <thead>
                    <tr>
                        {props.tableHeaders.map((item, index) => {
                            return <th key={`head${index}`} width={item.width}><center>{item.label}</center></th>
                        })}
                    </tr>
                </thead>
            </Table>

            <Droppable droppableId="droppable">
                {(provided) => {
                    return (
                        <Table>
                            <tbody className="draggable-bg" ref={provided.innerRef}>
                                {0 < props.draggableList.length ? (
                                    props.draggableList.map((item, index) => (
                                        <Draggable key={`row${index}`} draggableId={`row${index}`} index={index} isDragDisabled={props.isDragDisabled}>
                                            {(provided, snapshot) =>
                                                (
                                                    <tr
                                                        {...provided.dragHandleProps}
                                                        {...provided.draggableProps}
                                                        ref={provided.innerRef}
                                                        className={STORE_LIST === props.listKey ? (moment(moment().format(DATE_FORMAT)).isBetween(moment(item.storeStartDate).format(DATE_FORMAT), moment(item.storeEndDate).format(DATE_FORMAT), "days", true) ? "draggable-list" : "draggable-list-inactive") : "draggable-list"}
                                                        >

                                                        {props.tableColumns.map((column, i) => {

                                                            if (ADS_LIST === props.listKey) {
                                                                item = isNullOrUndefined(item.adsModel) ? item : item.adsModel;
                                                            }

                                                            if (0 <= ["startDate", "endDate", "storeStartDate", "storeEndDate"].indexOf(column)) {
                                                                return (
                                                                    <td key={column + i} style={{ border: 'transparent' }} id={`row${index}`} width={isNullOrUndefined(props.tableHeaders[i]) ? '20%' : props.tableHeaders[i].width}>
                                                                        <center>{moment(item[column]).format(DATE_FORMAT)}</center>
                                                                    </td>
                                                                );
                                                            }

                                                            if (STORE_SPONSORSHIP === column) {
                                                                return (
                                                                    <td key={column + i} style={{ border: 'transparent' }} id={`row${index}`} width={isNullOrUndefined(props.tableHeaders[i]) ? '20%' : props.tableHeaders[i].width}>
                                                                        <center>{parseFloat(item[column]).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</center>
                                                                    </td>
                                                                )
                                                            }

                                                            if (ADS_TITLE === column || STORE_NAME_DRAG === column) {
                                                                return (
                                                                    <td key={column + i} className="adsTitle" style={{ border: 'transparent' }} id={`row${index}`} width={isNullOrUndefined(props.tableHeaders[i]) ? '20%' : props.tableHeaders[i].width}>
                                                                        <center>{item[column]}</center>
                                                                    </td>
                                                                )
                                                            }

                                                            return (
                                                                <td key={column + i} style={{ border: 'transparent' }} id={`row${index}`} width={isNullOrUndefined(props.tableHeaders[i]) ? '20%' : props.tableHeaders[i].width}>
                                                                    <center>{item[column]}</center>
                                                                </td>
                                                            )
                                                        })}
                                                        {ROWBUTTONS_LENGTH < props.rowButtons.length && (
                                                            <td style={{ borderTop: 'none' }} width={props.tableHeaders[props.tableColumns.length].width}>
                                                                <center>
                                                                    {props.rowButtons.map((button, i) => {
                                                                        return <Button key={`rowIcon${i}`} variant={button.variant} onClick={() => button.onClick(item, button.type)}><button.icon color={button.color} size={20} /></Button>
                                                                    })}
                                                                </center>
                                                            </td>
                                                        )}

                                                    </tr>
                                                )}
                                        </Draggable>
                                    ))
                                ) : (
                                        <tr
                                            className="draggable-list"
                                        >
                                            <td colSpan={props.tableColumns.length} className="no-records">
                                                {NO_RECORDS_FOUND}
                                            </td>
                                        </tr>
                                    )}
                                {provided.placeholder}
                            </tbody>
                        </Table>
                    )
                }}
            </Droppable>
        </DragDropContext>
    );
};

export default DraggableTable;